import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/api/auth/auth.service";
import { MessageService } from "@openng/optimus-ui/api";
import { LangSwitchComponent } from "../../../shared/components/lang-switch/lang-switch.component";
import { first } from "rxjs";

@Component({
  standalone: true,
  selector: "app-forgot-password",
  imports: [TranslateModule, ReactiveFormsModule, InputTextModule, ButtonComponent, LangSwitchComponent],
  templateUrl: "./forgot-password.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./forgot-password.component.scss",
})
export class ForgotPasswordComponent {
  private translate = inject(TranslateService);
  public forgotPasswordForm: FormGroup = new FormGroup({
    username: new FormControl(null, Validators.required),
  });
  private auth = inject(AuthService);
  private router = inject(Router);
  private messageService = inject(MessageService);

  /**
   * Handle Enter key press event.
   * If pressed, calls `forgotPassword` method.
   * @param event KeyboardEvent
   */
  onKeyUp(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.forgotPassword();
    }
  }

  /**
   * Initiates the forgot password process by sending a reset request to the server.
   * Retrieves the email from the form, makes an API call through AuthService,
   * and displays a success message if the request is successful.
   * Navigates to the OTP page upon success.
   */

  forgotPassword() {
    const email = this.forgotPasswordForm.get("username")?.value;
    if (email) {
      this.auth
        .forgotPassword(email)
        .pipe(first())
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.messageService.add({
                key: "global",
                severity: "success",
                summary: this.translate.instant("common.success"),
                detail: this.translate.instant("auth.forgot_password.reset_request_success"),
                life: 5000,
              });
              this.router.navigate(["/otp"]);
            }
          },
        });
    }
  }
}
